import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'select-language',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'purchase-orders',
    loadChildren: () => import('./purchase-orders/purchase-orders.module').then(m => m.PurchaseOrdersPageModule)
  },
  {
    path: 'po-details/:po_id',
    loadChildren: () => import('./po-details/po-details.module').then(m => m.PoDetailsPageModule)
  },
  {
    path: 'add-shipment/:po_id',
    loadChildren: () => import('./add-shipment/add-shipment.module').then(m => m.AddShipmentPageModule)
  },
  {
    path: 'otp-login',
    loadChildren: () => import('./otp-login/otp-login.module').then(m => m.OtpLoginPageModule)
  },
  {
    path: 'post-supply',
    loadChildren: () => import('./post-supply/post-supply.module').then(m => m.PostSupplyPageModule)
  },
  {
    path: 'add-transporter',
    loadChildren: () => import('./add-transporter/add-transporter.module').then(m => m.AddTransporterPageModule)
  },
  {
    path: 'transporter-list',
    loadChildren: () => import('./transporter-list/transporter-list.module').then(m => m.TransporterListPageModule)
  },
  {
    path: 'payments/:cust_id',
    loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsPageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./history/history.module').then(m => m.HistoryPageModule)
  },
  {
    path: 'user-profile',
    loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfilePageModule)
  },
  {
    path: 'kyc-details/:cust_id',
    loadChildren: () => import('./kyc-details/kyc-details.module').then(m => m.KycDetailsPageModule)
  },
  {
    path: 'bank-account-details/:cust_id',
    loadChildren: () => import('./bank-account-details/bank-account-details.module').then(m => m.BankAccountDetailsPageModule)
  },
  {
    path: 'add-bankaccount',
    loadChildren: () => import('./add-bankaccount/add-bankaccount.module').then(m => m.AddBankaccountPageModule)
  },
  {
    path: 'edit-profile',
    loadChildren: () => import('./edit-profile/edit-profile.module').then(m => m.EditProfilePageModule)
  },
  {
    path: 'business-details',
    loadChildren: () => import('./business-details/business-details.module').then(m => m.BusinessDetailsPageModule)
  },
  {
    path: 'add-customer',
    loadChildren: () => import('./add-customer/add-customer.module').then(m => m.AddCustomerPageModule)
  },
  {
    path: 'my-supply',
    loadChildren: () => import('./my-supply/my-supply.module').then(m => m.MySupplyPageModule)
  },
  {
    path: 'customers-list',
    loadChildren: () => import('./customers-list/customers-list.module').then(m => m.CustomersListPageModule)
  },
  {
    path: 'post-shipment/:pur_id',
    loadChildren: () => import('./post-shipment/post-shipment.module').then(m => m.PostShipmentPageModule)
  },
  {
    path: 'select-language',
    loadChildren: () => import('./select-language/select-language.module').then(m => m.SelectLanguagePageModule)
  },
  {
    path: 'languages',
    loadChildren: () => import('./languages/languages.module').then(m => m.LanguagesPageModule)
  },
  {
    path: 'add-rfq',
    loadChildren: () => import('./add-rfq/add-rfq.module').then(m => m.AddRfqPageModule)
  },
  {
    path: 'rfq-list',
    loadChildren: () => import('./rfq-list/rfq-list.module').then(m => m.RfqListPageModule)
  },
  {
    path: 'edit-customer/:cust_id',
    loadChildren: () => import('./edit-customer/edit-customer.module').then(m => m.EditCustomerPageModule)
  },
  {
    path: 'sells-product/:cust_id',
    loadChildren: () => import('./sells-product/sells-product.module').then(m => m.SellsProductPageModule)
  },
  {
    path: 'buys-product/:cust_id',
    loadChildren: () => import('./buys-product/buys-product.module').then(m => m.BuysProductPageModule)
  },
  {
    path: 'customer-details/:cust_id',
    loadChildren: () => import('./customer-details/customer-details.module').then(m => m.CustomerDetailsPageModule)
  },
  {
    path: 'rfq-details/:rfq_id',
    loadChildren: () => import('./rfq-details/rfq-details.module').then(m => m.RfqDetailsPageModule)
  },
  {
    path: 'enquiry-list',
    loadChildren: () => import('./enquiry-list/enquiry-list.module').then(m => m.EnquiryListPageModule)
  },
  {
    path: 'enquiry-details',
    loadChildren: () => import('./enquiry-details/enquiry-details.module').then(m => m.EnquiryDetailsPageModule)
  },
  {
    path: 'received-quotes',
    loadChildren: () => import('./received-quotes/received-quotes.module').then(m => m.ReceivedQuotesPageModule)
  },
  {
    path: 'trade-details/:cust_id',
    loadChildren: () => import('./trade-details/trade-details.module').then(m => m.TradeDetailsPageModule)
  },
  {
    path: 'edit-shipment/:sno',
    loadChildren: () => import('./edit-shipment/edit-shipment.module').then(m => m.EditShipmentPageModule)
  },
  {
    path: 'mysupply-list/:supply_id',
    loadChildren: () => import('./mysupply-details/mysupply-list.module').then(m => m.MysupplyListPageModule)
  },
  {
    path: 'edit-logistics/:pur_id',
    loadChildren: () => import('./edit-logistics/edit-logistics.module').then(m => m.EditLogisticsPageModule)
  },
  {
    path: 'add-custstock-point',
    loadChildren: () => import('./add-custstock-point/add-custstock-point.module').then(m => m.AddCuststockPointPageModule)
  },
  {
    path: 'checkin-customer/:cust_id',
    loadChildren: () => import('./checkin-customer/checkin-customer.module').then(m => m.CheckinCustomerPageModule)
  },
  {
    path: 'password-change',
    loadChildren: () => import('./password-change/password-change.module').then(m => m.PasswordChangePageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'sales-order',
    loadChildren: () => import('./sales-order/sales-order.module').then(m => m.SalesOrderPageModule)
  },
  {
    path: 'sales-order-details/:so_id',
    loadChildren: () => import('./sales-order-details/sales-order-details.module').then(m => m.SalesOrderDetailsPageModule)
  },
  {
    path: 'add-sales-order',
    loadChildren: () => import('./add-sales-order/add-sales-order.module').then(m => m.AddSalesOrderPageModule)
  },
  {
    path: 'add-po/:so_id',
    loadChildren: () => import('./add-po/add-po.module').then(m => m.AddPoPageModule)
  },
  {
    path: 'choose-supplierbid/:so_id',
    loadChildren: () => import('./choose-supplierbid/choose-supplierbid.module').then(m => m.ChooseSupplierbidPageModule)
  },
  {
    path: 'create-sales-invoice',
    loadChildren: () => import('./create-sales-invoice/create-sales-invoice.module').then(m => m.CreateSalesInvoicePageModule)
  },
  {
    path: 'choose-purchase',
    loadChildren: () => import('./choose-purchase/choose-purchase.module').then(m => m.ChoosePurchasePageModule)
  },
  {
    path: 'add-saleline/:so_id',
    loadChildren: () => import('./add-saleline/add-saleline.module').then(m => m.AddSalelinePageModule)
  },
  {
    path: 'track',
    loadChildren: () => import('./track/track.module').then(m => m.TrackPageModule)
  },
  {
    path: 'payment-request/:pur_id',
    loadChildren: () => import('./payment-request/payment-request.module').then(m => m.PaymentRequestPageModule)
  },
  {
    path: 'payment-req-list/:pur_id',
    loadChildren: () => import('./payment-req-list/payment-req-list.module').then(m => m.PaymentReqListPageModule)
  },
  {
    path: 'edit-custstock-point',
    loadChildren: () => import('./edit-custstock-point/edit-custstock-point.module').then(m => m.EditCuststockPointPageModule)
  },
  {
    path: 'upload-mr/:sale_id',
    loadChildren: () => import('./upload-mr/upload-mr.module').then(m => m.UploadMRPageModule)
  },
  {
    path: 'quote-your-bid',
    loadChildren: () => import('./quote-your-bid/quote-your-bid.module').then(m => m.QuoteYourBidPageModule)
  },
  {
    path: 'upload-frs/:sale_id',
    loadChildren: () => import('./upload-frs/upload-frs.module').then(m => m.UploadFrsPageModule)
  },
  {
    path: 'purchase-list',
    loadChildren: () => import('./purchase-list/purchase-list.module').then(m => m.PurchaseListPageModule)
  },
  {
    path: 'sales-list',
    loadChildren: () => import('./sales-list/sales-list.module').then(m => m.SalesListPageModule)
  },
  {
    path: 'job-process',
    loadChildren: () => import('./job-process/job-process.module').then(m => m.JobProcessPageModule)
  },
  {
    path: 'dashboard-graph',
    loadChildren: () => import('./dashboard-graph/dashboard-graph.module').then(m => m.DashboardGraphPageModule)
  },
  {
    path: 'add-direct-po',
    loadChildren: () => import('./add-direct-po/add-direct-po.module').then(m => m.AddDirectPoPageModule)
  },
  {
    path: 'add-direct-sale/:so_id',
    loadChildren: () => import('./add-direct-sale/add-direct-sale.module').then(m => m.AddDirectSalePageModule)
  },
  {
    path: 'direct-sale-details/:sale_id',
    loadChildren: () => import('./direct-sale-details/direct-sale-details.module').then(m => m.DirectSaleDetailsPageModule)
  },
  {
    path: 'add-sale-logistics/:sale_id',
    loadChildren: () => import('./add-sale-logistics/add-sale-logistics.module').then(m => m.AddSaleLogisticsPageModule)
  },
  {
    path: 'prn-list',
    loadChildren: () => import('./prn-list/prn-list.module').then(m => m.PrnListPageModule)
  },
  {
    path: 'srn-list',
    loadChildren: () => import('./srn-list/srn-list.module').then(m => m.SrnListPageModule)
  },
  {
    path: 'payment-req-details/:pmt_req_id',
    loadChildren: () => import('./payment-req-details/payment-req-details.module').then(m => m.PaymentReqDetailsPageModule)
  },
  {
    path: 'edit-transporter/:trans_id',
    loadChildren: () => import('./edit-transporter/edit-transporter.module').then(m => m.EditTransporterPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'add-secondary-rm/:so_id',
    loadChildren: () => import('./add-secondary-rm/add-secondary-rm.module').then(m => m.AddSecondaryRMPageModule)
  },
  {
    path: 'add-sales-order-material/:so_id',
    loadChildren: () => import('./add-sales-order-material/add-sales-order-material.module').then(m => m.AddSalesOrderMaterialPageModule)
  },
  {
    path: 'add-po-material',
    loadChildren: () => import('./add-po-material/add-po-material.module').then(m => m.AddPoMaterialPageModule)
  },
  {
    path: 'replace-po-line/:po_id/:po_line_id',
    loadChildren: () => import('./replace-po-line/replace-po-line.module').then(m => m.ReplacePoLinePageModule)
  },
  {
    path: 'add-multi-shipment',
    loadChildren: () => import('./add-multi-shipment/add-multi-shipment.module').then(m => m.AddMultiShipmentPageModule)
  },
  {
    path: 'select-multi-poline/:po_id',
    loadChildren: () => import('./select-multi-poline/select-multi-poline.module').then(m => m.SelectMultiPolinePageModule)
  },
  {
    path: 'add-directpo-material/:po_id',
    loadChildren: () => import('./add-directpo-material/add-directpo-material.module').then(m => m.AddDirectpoMaterialPageModule)
  },
  {
    path: 'add-direct-sale-material',
    loadChildren: () => import('./add-direct-sale-material/add-direct-sale-material.module').then(m => m.AddDirectSaleMaterialPageModule)
  },
  {
    path: 'add-adv-payment',
    loadChildren: () => import('./add-adv-payment/add-adv-payment.module').then(m => m.AddAdvPaymentPageModule)
  },
  {
    path: 'adv-payments-list',
    loadChildren: () => import('./adv-payments-list/adv-payments-list.module').then(m => m.AdvPaymentsListPageModule)
  },
  {
    path: 'upload-pur-mr/:pur_id',
    loadChildren: () => import('./upload-pur-mr/upload-pur-mr.module').then(m => m.UploadPurMrPageModule)
  },
  {
    path: 'edit-sales-order/:so_id',
    loadChildren: () => import('./edit-sales-order/edit-sales-order.module').then(m => m.EditSalesOrderPageModule)
  },
  {
    path: 'add-opportunity',
    loadChildren: () => import('./add-opportunity/add-opportunity.module').then(m => m.AddOpportunityPageModule)
  },
  {
    path: 'opportunity-list',
    loadChildren: () => import('./opportunity-list/opportunity-list.module').then(m => m.OpportunityListPageModule)
  },
  {
    path: 'add-opportunity-so',
    loadChildren: () => import('./add-opportunity-so/add-opportunity-so.module').then(m => m.AddOpportunitySoPageModule)
  },
  {
    path: 'add-import-shipment/:po_id',
    loadChildren: () => import('./add-import-shipment/add-import-shipment.module').then(m => m.AddImportShipmentPageModule)
  },
  {
    path: 'add-import-purchase-order/:so_id',
    loadChildren: () => import('./add-import-purchase-order/add-import-purchase-order.module').then(m => m.AddImportPurchaseOrderPageModule)
  },
  {
    path: 'add-import-direct-sale/:so_id',
    loadChildren: () => import('./add-import-direct-sale/add-import-direct-sale.module').then(m => m.AddImportDirectSalePageModule)
  },
  {
    path: 'payment-request-cust/:cpmt_req_id',
    loadChildren: () => import('./payment-request-cust/payment-request-cust.module').then(m => m.PaymentRequestCustPageModule)
  },
  {
    path: 'payment-req-details-cust/:pmt_req_id',
    loadChildren: () => import('./payment-req-details-cust/payment-req-details-cust.module').then(m => m.PaymentReqDetailsCustPageModule)
  },
  {
    path: 'activate/:acti_req_id',
    loadChildren: () => import('./activate/activate.module').then(m => m.ActivatePageModule)
  },
  {
    path: 'documents-upload',
    loadChildren: () => import('./documents-upload/documents-upload.module').then(m => m.DocumentsUploadPageModule)
  },
  {
    path: 'add-secondary-rm-po/:po_id',
    loadChildren: () => import('./add-secondary-rm-po/add-secondary-rm-po.module').then(m => m.AddSecondaryRMPoPageModule)
  },
  {
    path: 'tcb-list',
    loadChildren: () => import('./tcb-list/tcb-list.module').then(m => m.TcbListPageModule)
  },
  {
    path: 'tcb-ch-approval-list',
    loadChildren: () => import('./tcb-ch-approval-list/tcb-ch-approval-list.module').then(m => m.TcbChApprovalListPageModule)
  },
  {
    path: 'tcb-ch-approval-details',
    loadChildren: () => import('./tcb-ch-approval-details/tcb-ch-approval-details.module').then(m => m.TcbChApprovalDetailsPageModule)
  },
  {
    path: 'tcb-details',
    loadChildren: () => import('./tcb-details/tcb-details.module').then(m => m.TcbDetailsPageModule)
  },
  {
    path: 'tcb-buyer-create',
    loadChildren: () => import('./tcb-buyer-create/tcb-buyer-create.module').then(m => m.TcbBuyerCreatePageModule)
  },
  {
    path: 'tcb-material-create',
    loadChildren: () => import('./tcb-material-create/tcb-material-create.module').then(m => m.TcbMaterialCreatePageModule)
  },
  {
    path: 'tcb-supplier-create',
    loadChildren: () => import('./tcb-supplier-create/tcb-supplier-create.module').then(m => m.TcbSupplierCreatePageModule)
  },
  {
    path: 'tcb-buyer-material',
    loadChildren: () => import('./tcb-buyer-material/tcb-buyer-material.module').then(m => m.TcbBuyerMaterialPageModule)
  },
  {
    path: 'tcb-supplier-material',
    loadChildren: () => import('./tcb-supplier-material/tcb-supplier-material.module').then(m => m.TcbSupplierMaterialPageModule)
  },
  {
    path: 'tcb-summary-create',
    loadChildren: () => import('./tcb-summary-create/tcb-summary-create.module').then(m => m.TcbSummaryCreatePageModule)
  },
  {
    path: 'tcb-b2b-summary',
    loadChildren: () => import('./tcb-b2b-summary/tcb-b2b-summary.module').then(m => m.TcbB2bSummaryPageModule)
  },
  {
    path: 'tcb-trans-type',
    loadChildren: () => import('./tcb-trans-type/tcb-trans-type.module').then(m => m.TcbTransTypePageModule)
  },
  {
    path: 'materials-list',
    loadChildren: () => import('./materials-list/materials-list.module').then(m => m.MaterialsListPageModule)
  },
  {
    path: 'payments-list',
    loadChildren: () => import('./payments-list/payments-list.module').then(m => m.PaymentsListPageModule)
  },
  {
    path: 'tcb-buyer-update/:tcb_buyer_id',
    loadChildren: () => import('./tcb-buyer-update/tcb-buyer-update.module').then(m => m.TcbBuyerUpdatePageModule)
  },
  {
    path: 'tcb-supplier-update/:tcb_supplier_id',
    loadChildren: () => import('./tcb-supplier-update/tcb-supplier-update.module').then(m => m.TcbSupplierUpdatePageModule)
  },
  {
    path: 'tcb-buyer-mat-update/:tcb_buyer_details_id',
    loadChildren: () => import('./tcb-buyer-mat-update/tcb-buyer-mat-update.module').then(m => m.TcbBuyerMatUpdatePageModule)
  },
  {
    path: 'tcb-supplier-mat-update/:tcb_supplier_details_id',
    loadChildren: () => import('./tcb-supplier-mat-update/tcb-supplier-mat-update.module').then(m => m.TcbSupplierMatUpdatePageModule)
  },
  {
    path: 'tcb-buyer-mat-add/:tcb_buyer_id',
    loadChildren: () => import('./tcb-buyer-mat-add/tcb-buyer-mat-add.module').then(m => m.TcbBuyerMatAddPageModule)
  },
  {
    path: 'tcb-supplier-mat-add/:tcb_supplier_id',
    loadChildren: () => import('./tcb-supplier-mat-add/tcb-supplier-mat-add.module').then(m => m.TcbSupplierMatAddPageModule)
  },
  {
    path: 'tcb-import-so/:tcb_buyer_id',
    loadChildren: () => import('./tcb-import-so/tcb-import-so.module').then(m => m.TcbImportSoPageModule)
  },
  {
    path: 'tcb-import-po/:so_id',
    loadChildren: () => import('./tcb-import-po/tcb-import-po.module').then(m => m.TcbImportPoPageModule)
  },
  {
    path: 'ft-customer-list',
    loadChildren: () => import('./ft-customer-list/ft-customer-list.module').then(m => m.FtCustomerListPageModule)
  },
  {
    path: 'ft-customer-details/:comp_id',
    loadChildren: () => import('./ft-customer-details/ft-customer-details.module').then(m => m.FtCustomerDetailsPageModule)
  },
  {
    path: 'ft-add-customer',
    loadChildren: () => import('./ft-add-customer/ft-add-customer.module').then(m => m.FtAddCustomerPageModule)
  },
  {
    path: 'ft-edit-customer/:comp_id',
    loadChildren: () => import('./ft-edit-customer/ft-edit-customer.module').then(m => m.FtEditCustomerPageModule)
  },
  {
    path: 'ft-cust-buys-product/:comp_id',
    loadChildren: () => import('./ft-cust-buys-product/ft-cust-buys-product.module').then(m => m.FtCustBuysProductPageModule)
  },
  {
    path: 'ft-cust-sells-product/:comp_id',
    loadChildren: () => import('./ft-cust-sells-product/ft-cust-sells-product.module').then(m => m.FtCustSellsProductPageModule)
  },
  {
    path: 'ft-company-contact-person/:comp_id',
    loadChildren: () => import('./ft-company-contact-person/ft-company-contact-person.module').then(m => m.FtCompanyContactPersonPageModule)
  },
  {
    path: 'ft-add-company-contact-details/:comp_id',
    loadChildren: () => import('./ft-add-company-contact-details/ft-add-company-contact-details.module').then(m => m.FtAddCompanyContactDetailsPageModule)
  },
  {
    path: 'ft-add-company-kyc-details',
    loadChildren: () => import('./ft-add-company-kyc-details/ft-add-company-kyc-details.module').then(m => m.FtAddCompanyKycDetailsPageModule)
  },
  {
    path: 'add-farmer',
    loadChildren: () => import('./ipm-add-farmer/add-farmer.module').then(m => m.AddFarmerPageModule)
  },
  {
    path: 'edit-farmer/:cust_id',
    loadChildren: () => import('./ipm-edit-farmer/edit-farmer.module').then(m => m.EditFarmerPageModule)
  },
  {
    path: 'farmer-land-details',
    loadChildren: () => import('./ipm-farmer-land-details/farmer-land-details.module').then(m => m.FarmerLandDetailsPageModule)
  },
  {
    path: 'ipm-list',
    loadChildren: () => import('./ipm-list/ipm-list.module').then(m => m.IpmListPageModule)
  },
  {
    path: 'ipm-details/:cust_id',
    loadChildren: () => import('./ipm-details/ipm-details.module').then(m => m.IpmDetailsPageModule)
  },
  {
    path: 'farm-study-list',
    loadChildren: () => import('./ipm-farm-study-list/farm-study-list.module').then(m => m.FarmStudyListPageModule)
  },
  {
    path: 'farm-study-create',
    loadChildren: () => import('./ipm-farm-study-create/farm-study-create.module').then(m => m.FarmStudyCreatePageModule)
  },
  {
    path: 'ipm-add-farm-cycle',
    loadChildren: () => import('./ipm-add-farm-cycle/ipm-add-farm-cycle.module').then(m => m.IpmAddFarmCyclePageModule)
  },
  {
    path: 'ipm-edit-farm-cycle',
    loadChildren: () => import('./ipm-edit-farm-cycle/ipm-edit-farm-cycle.module').then(m => m.IpmEditFarmCyclePageModule)
  },
  {
    path: 'ipm-farm-study-update/:farm_activity_id',
    loadChildren: () => import('./ipm-farm-study-update/ipm-farm-study-update.module').then(m => m.IpmFarmStudyUpdatePageModule)
  },
  {
    path: 'ipm-farm-mgmt-docs',
    loadChildren: () => import('./ipm-farm-mgmt-docs/ipm-farm-mgmt-docs.module').then(m => m.IpmFarmMgmtDocsPageModule)
  },
  {
    path: 'ipm-admin-farm-activity-list',
    loadChildren: () => import('./ipm-admin-farm-activity-list/ipm-admin-farm-activity-list.module').then(m => m.IpmAdminFarmActivityListPageModule)
  },
  {
    path: 'ipm-admin-farm-activity/:farm_activity_id',
    loadChildren: () => import('./ipm-admin-farm-activity/ipm-admin-farm-activity.module').then(m => m.IpmAdminFarmActivityPageModule)
  },
  {
    path: 'ipm-farm-activity-create',
    loadChildren: () => import('./ipm-farm-activity-create/ipm-farm-activity-create.module').then(m => m.IpmFarmActivityCreatePageModule)
  },
  {
    path: 'ipm-farm-activity-update/:farm_activity_id',
    loadChildren: () => import('./ipm-farm-activity-update/ipm-farm-activity-update.module').then(m => m.IpmFarmActivityUpdatePageModule)
  },
  {
    path: 'ft-customer-consent/:comp_id',
    loadChildren: () => import('./ft-customer-consent/ft-customer-consent.module').then(m => m.FtCustomerConsentPageModule)
  },
  {
    path: 'ft-add-buss-type',
    loadChildren: () => import('./ft-add-buss-type/ft-add-buss-type.module').then(m => m.FtAddBussTypePageModule)
  },
  {
    path: 'ft-add-pid-company/:comp_id',
    loadChildren: () => import('./ft-add-pid-company/ft-add-pid-company.module').then(m => m.FtAddPidCompanyPageModule)
  },
  {
    path: 'ft-case-list/:comp_id/:fi_id/:prgm_id',
    loadChildren: () => import('./ft-case-list/ft-case-list.module').then(m => m.FtCaseListPageModule)
  },
  {
    path: 'ft-case-details/:case_id',
    loadChildren: () => import('./ft-case-details/ft-case-details.module').then(m => m.FtCaseDetailsPageModule)
  },
  {
    path: 'ft-case-creation/:comp_id/:fi_id',
    loadChildren: () => import('./ft-case-creation/ft-case-creation.module').then(m => m.FtCaseCreationPageModule)
  },
  {
    path: 'ft-case-invoice-addition/:case_id',
    loadChildren: () => import('./ft-case-invoice-addition/ft-case-invoice-addition.module').then(m => m.FtCaseInvoiceAdditionPageModule)
  },
  {
    path: 'ft-case-comp-lender/:comp_id',
    loadChildren: () => import('./ft-case-comp-lender/ft-case-comp-lender.module').then(m => m.FtCaseCompLenderPageModule)
  },
  {
    path: 'ft-case-comp-list',
    loadChildren: () => import('./ft-case-comp-list/ft-case-comp-list.module').then(m => m.FtCaseCompListPageModule)
  },
  {
    path: 'ft-case-creation-invoice/:comp_id/:fi_id/:fi_app_id/:prgm_id',
    loadChildren: () => import('./ft-case-creation-invoice/ft-case-creation-invoice.module').then(m => m.FtCaseCreationInvoicePageModule)
  },
  {
    path: 'ft-add-sid-buyer/:comp_id',
    loadChildren: () => import('./ft-add-sid-buyer/ft-add-sid-buyer.module').then(m => m.FtAddSidBuyerPageModule)
  },
  {
    path: 'ft-add-credit-evaluation/:comp_id',
    loadChildren: () => import('./ft-add-credit-evaluation/ft-add-credit-evaluation.module').then(m => m.FtAddCreditEvaluationPageModule)
  },
  {
    path: 'ft-add-cust-buysells/:comp_id',
    loadChildren: () => import('./ft-add-cust-buysells/ft-add-cust-buysells.module').then(m => m.FtAddCustBuysellsPageModule)
  },
  {
    path: 'payment-early-req-list',
    loadChildren: () => import('./payment-early-req-list/payment-early-req-list.module').then(m => m.PaymentEarlyReqListPageModule)
  },
  {
    path: 'payment-tal-req-list',
    loadChildren: () => import('./payment-tal-req-list/payment-tal-req-list.module').then(m => m.PaymentTalReqListPageModule)
  },
  {
    path: 'payment-tal-detail/:id',
    loadChildren: () => import('./payment-tal-detail/payment-tal-detail.module').then(m => m.PaymentTalDetailPageModule)
  },
  {
    path: 'payment-early-req-details/:pmt_req_grp_id',
    loadChildren: () => import('./payment-early-req-details/payment-early-req-details.module').then(m => m.PaymentEarlyReqDetailsPageModule)
  },
  {
    path: 'ipm-farm-harvest-list',
    loadChildren: () => import('./ipm-farm-harvest-list/ipm-farm-harvest-list.module').then(m => m.IpmFarmHarvestListPageModule)
  },
  {
    path: 'ipm-farm-harvest-manage',
    loadChildren: () => import('./ipm-farm-harvest-manage/ipm-farm-harvest-manage.module').then(m => m.IpmFarmHarvestManagePageModule)
  },
  {
    path: 'ipm-farm-qc-list',
    loadChildren: () => import('./ipm-farm-qc-list/ipm-farm-qc-list.module').then(m => m.IpmFarmQcListPageModule)
  },
  {
    path: 'ipm-farm-qc-manage',
    loadChildren: () => import('./ipm-farm-qc-manage/ipm-farm-qc-manage.module').then(m => m.IpmFarmQcManagePageModule)
  },
  {
    path: 'ipm-farm-inventory-list',
    loadChildren: () => import('./ipm-farm-inventory-list/ipm-farm-inventory-list.module').then(m => m.IpmFarmInventoryListPageModule)
  },
  {
    path: 'ipm-farm-inventory-manage/:lot_id',
    loadChildren: () => import('./ipm-farm-inventory-manage/ipm-farm-inventory-manage.module').then(m => m.IpmFarmInventoryManagePageModule)
  },
  {
    path: 'tcb-import-est/:tcb_buyer_id',
    loadChildren: () => import('./tcb-import-est/tcb-import-est.module').then( m => m.TcbImportEstPageModule)
  },
  {
    path: 'estimation-list',
    loadChildren: () => import('./estimation-list/estimation-list.module').then( m => m.EstimationListPageModule)
  },
  {
    path: 'estimation-details/:esti_id',
    loadChildren: () => import('./estimation-details/estimation-details.module').then( m => m.EstimationDetailsPageModule)
  },
  {
    path: 'estimation-addition',
    loadChildren: () => import('./estimation-addition/estimation-addition.module').then( m => m.EstimationAdditionPageModule)
  },
  {
    path: 'estimation-add-material/:esti_id',
    loadChildren: () => import('./estimation-add-material/estimation-add-material.module').then( m => m.EstimationAddMaterialPageModule)
  },
  {
    path: 'estimation-addition-so/:esti_id',
    loadChildren: () => import('./estimation-addition-so/estimation-addition-so.module').then( m => m.EstimationAdditionSoPageModule)
  },
  {
    path: 'ft-edit-credit-evaluation/:comp_id',
    loadChildren: () => import('./ft-edit-credit-evaluation/ft-edit-credit-evaluation.module').then( m => m.FtEditCreditEvaluationPageModule)
  },
  {
    path: 'ft-make-payment/:comp_id',
    loadChildren: () => import('./ft-make-payment/ft-make-payment.module').then( m => m.FtMakePaymentPageModule)
  },
  {
    path: 'sop-checklist/:txn_type/:ref_id',
    loadChildren: () => import('./sop-checklist/sop-checklist.module').then(m => m.SopChecklistPageModule)
  },
  {
    path: 'ft-referred-verification/:comp_id',
    loadChildren: () => import('./ft-referred-verification/ft-referred-verification.module').then( m => m.FtReferredVerificationPageModule)
  },
  {
    path: 'production-list',
    loadChildren: () => import('./production-list/production-list.module').then(m => m.ProductionListPageModule)
  },
  {
    path: 'production-details/:prod_id',
    loadChildren: () => import('./production-details/production-details.module').then(m => m.ProductionDetailsPageModule)
  },
  {
    path: 'add-production',
    loadChildren: () => import('./add-production/add-production.module').then(m => m.AddProductionPageModule)
  },  
  {
    path: 'support-guide',
    loadChildren: () => import('./support-guide/support-guide.module').then(m => m.SupportGuidePageModule)
  },
  {
    path: 'overseas-sales-list',
    loadChildren: () => import('./overseas-sales-list/overseas-sales-list.module').then(m => m.OverseasSalesListPageModule)
  },
  {
    path: 'add-overseas-sale',
    loadChildren: () => import('./add-overseas-sale/add-overseas-sale.module').then(m => m.AddOverseasSalePageModule)
  },
  {
    path: 'overseas-sale-details/:sale_id',
    loadChildren: () => import('./overseas-sale-details/overseas-sale-details.module').then(m => m.OverseasSaleDetailsPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
